import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const WindowType = ({ value, onChange, id='WindowType', label = 'Window Type:', disabled = false, showPics = false }) => {
    const [selectedWindowType, setSelectedWindowType] = useState(value || "");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedWindowType(value || "");
    }, [value]);

    const handleWindowTypeChange = (e) => {
        setSelectedWindowType(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="WindowType" disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedWindowType}
                onChange={handleWindowTypeChange}
            >
                {/*<option value="" disabled hidden>Select an option</option>*/}
                <option value="None">{selectedWindowType === "None" ? "None ✔" : "None"}</option>
                <option value="Picture">{selectedWindowType === "Picture" ? "★ Picture ✔" : "★ Picture"}</option>
                <option value="Fixed Casement">{selectedWindowType === "Fixed Casement" ? "Fixed Casement ✔" : "Fixed Casement"}</option>
                <option value="Double Slider Tilt">{selectedWindowType === "Double Slider Tilt" ? "Double Slider Tilt ✔" : "Double Slider Tilt"}</option>
                <option value="Double Hung Tilt">{selectedWindowType === "Double Hung Tilt" ? "Double Hung Tilt ✔" : "Double Hung Tilt"}</option>
                <option value="Casement">{selectedWindowType === "Casement" ? "Casement ✔" : "Casement"}</option>
                {/*<option value="Casement2">{selectedWindowType === "Casement2" ? "Double Casement ✔" : "Double Casement"}</option>*/}
                <option value="Awning">{selectedWindowType === "Awning" ? "Awning ✔" : "Awning"}</option>
                <option value="End-Vent">{selectedWindowType === "End-Vent" ? "End-Vent ✔" : "End-Vent"}</option>
                <option value="Single Slider Tilt">{selectedWindowType === "Single Slider Tilt" ? "Single Slider Tilt ✔" : "Single Slider Tilt"}</option>
                <option value="Single Hung Tilt">{selectedWindowType === "Single Hung Tilt" ? "Single Hung Tilt ✔" : "Single Hung Tilt"}</option>
                <option value="Tilt and Turn">{selectedWindowType === "Tilt and Turn" ? "Tilt and Turn ✔" : "Tilt and Turn"}</option>
                <option value="Oculus">{selectedWindowType === "Oculus" ? "Oculus ✔" : "Oculus"}</option>

                {/*
                <option value="Fixed Tilt&Turn">{selectedWindowType === "Fixed Tilt&Turn" ? "Fixed Tilt&Turn ✔" : "Fixed Tilt&Turn"}</option>
                <option value="Turn Only">{selectedWindowType === "Turn Only" ? "Turn Only ✔" : "Turn Only"}</option>
                */}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/windowtype"
                imageName={selectedWindowType}
                width={200}  //optional
                height={250} //optional
            />
        </div>
    );
};

export default WindowType;
